var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0103 18.61C7.84563 17.2696 5.83372 15.6969 4.01026 13.92C2.72149 12.6324 1.74039 11.0701 1.14026 9.35001C0.0702635 6.00001 1.32028 2.17001 4.84028 1.04001C5.75229 0.747256 6.7211 0.677108 7.66578 0.835424C8.61045 0.99374 9.50353 1.37589 10.2703 1.94999C11.0359 1.37749 11.9272 0.996216 12.8699 0.837926C13.8127 0.679637 14.7797 0.748945 15.6903 1.04001C19.2103 2.17001 20.4703 6.04001 19.4003 9.35001C18.8049 11.0724 17.8232 12.6357 16.5303 13.92C14.7068 15.6969 12.6949 17.2696 10.5303 18.61L10.3002 18.75L10.0103 18.61Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.150194a4dfae63846cce1e0b29653d28.svg";
export { ForwardRef as ReactComponent };